import { FadeIn } from "./FadeIn";

const CONTACTS = [
  { label: "Studio", value: "therzeszowarchive@gmail.com" },
];

const ELSEWHERE = [
  {
    label: "Spotify",
    href: "https://open.spotify.com/track/6aZiFZfJHWGPvSRnZtV2ae?si=912a3f72cff9473e",
  },
  { label: "Instagram", href: "https://www.instagram.com/kachevsky.archive/" },
];

export const Contact = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-32 md:py-48 px-6 sm:px-10 md:px-16 border-t border-[#141414]"
    >
      <div className="max-w-7xl mx-auto">
        <FadeIn>
          <div className="flex items-center gap-4 mb-16 md:mb-24">
            <span className="kv-overline text-[#6b6b6b]">N° 04</span>
            <span className="h-px flex-1 bg-[#1a1a1a]" />
            <span className="kv-overline text-[#a3a3a3]">Inquiries</span>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-16">
          <FadeIn className="md:col-span-7">
            <h2 className="font-serif-display text-[#f2f0e9] text-4xl sm:text-5xl md:text-6xl leading-[1.02] mb-12 italic whitespace-nowrap">
              Write, quietly.
            </h2>

            <div
              data-testid="contact-list"
              className="border-t border-[#1a1a1a]"
            >
              {CONTACTS.map((c) => (
                <a
                  key={c.label}
                  href={`mailto:${c.value}`}
                  data-testid={`contact-${c.label.toLowerCase()}`}
                  className="group grid grid-cols-12 gap-4 items-baseline py-6 border-b border-[#141414] transition-colors duration-700 hover:bg-white/[0.015]"
                >
                  <span className="col-span-4 sm:col-span-3 kv-overline text-[#6b6b6b]">
                    {c.label}
                  </span>
                  <span className="col-span-8 sm:col-span-9 font-mono-archive text-sm sm:text-base text-[#a3a3a3] group-hover:text-[#f2f0e9] transition-colors duration-700">
                    {c.value}
                  </span>
                </a>
              ))}
            </div>
          </FadeIn>

          <FadeIn className="md:col-span-4 md:col-start-9" delay={0.2}>
            <p className="kv-overline text-[#6b6b6b] mb-6">Elsewhere</p>
            <ul className="space-y-3">
              {ELSEWHERE.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target={link.href.startsWith("http") ? "_blank" : undefined}
                    rel={link.href.startsWith("http") ? "noopener noreferrer" : undefined}
                    data-testid={`social-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                    className="kv-link text-sm tracking-wide"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>

            <div className="mt-16 pt-8 max-w-xs" />
          </FadeIn>
        </div>
      </div>
    </section>
  );
};

export default Contact;
